export default __webpack_public_path__ + "static/media/LogoBianco.f75a67ab.png";